import React, { useEffect, useState } from 'react';
import HOME_TOPIC_ONE from '../../utils/assets/png/Conatctus-scale.png';
import THANK_YOU_EMAIL_SENT from '../../utils/assets/png/ThankYou-EmailSent-Orange.png';
import { Box, Grid, TextField } from '@mui/material';
import AtomicButton from '../../atomic/button/Button';

const ContactUs = () => {
  const [messageSent, setMessageSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zipcode: '',
    company: '',
    message: '',
  });

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zipcode: '',
    company: '',
    message: '',
  });

  // 🔍 log whenever messageSent changes
  useEffect(() => {
    console.log('messageSent state changed =>', messageSent);
  }, [messageSent]);

  // very simple XSS / script guard
  const hasDangerousContent = (value) => {
    if (!value) return false;
    const lower = value.toLowerCase();
    return (
      lower.includes('<script') ||
      /<\/?[a-z][\s\S]*>/i.test(lower) || // any HTML tag
      /javascript:/i.test(lower)
    );
  };

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));

    // clear error for that field when user types
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: '' }));
    }
  };

  const validate = () => {
    console.log('Validating form…', formData);
    const newErrors = {};

    // required + basic XSS check for all fields
    Object.entries(formData).forEach(([key, value]) => {
      const trimmed = value.trim();
      if (!trimmed) {
        newErrors[key] = 'This field is required';
      } else if (hasDangerousContent(trimmed)) {
        newErrors[key] = 'Invalid characters detected';
      }
    });

    // specific validations
    if (!newErrors.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email.trim())) {
        newErrors.email = 'Enter a valid email address';
      }
    }

    if (!newErrors.phone) {
      const phoneRegex = /^[0-9+\-\s()]{7,20}$/;
      if (!phoneRegex.test(formData.phone.trim())) {
        newErrors.phone = 'Enter a valid phone number';
      }
    }

    if (!newErrors.zipcode) {
      const zipRegex = /^[0-9]{4,10}$/;
      if (!zipRegex.test(formData.zipcode.trim())) {
        newErrors.zipcode = 'Enter a valid zipcode';
      }
    }

    if (!newErrors.message) {
      if (formData.message.trim().length < 10) {
        newErrors.message = 'Message should be at least 10 characters';
      }
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.keys(newErrors).length === 0;
    console.log('Validation result =>', isValid, newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    console.log('🔘 handleSubmit called');
    if (isSubmitting) {
      console.log('Already submitting, ignoring click');
      return;
    }

    const isValid = validate();
    if (!isValid) {
      console.log('❌ Form invalid – not sending API');
      return;
    }

    try {
      setIsSubmitting(true);
      console.log('🚀 Sending request to /api/contact-us with body:', formData);

      // const res = await fetch('/api/contact-us', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(formData),
      // });

      // console.log('📩 API response status:', res.status);

      // let data = null;
      // try {
      //   data = await res.json();
      //   console.log('📦 API response JSON:', data);
      // } catch (jsonErr) {
      //   console.log('No JSON body or failed to parse JSON:', jsonErr);
      // }

      // if (!res.ok) {
      //   console.error('❌ API returned non-2xx status');
      //   // You can surface error to user here if you want
      //   return;
      // }

      // If your backend includes a success flag, you can also check:
      // if (data && data.success === false) { ... }

      console.log('✅ API call successful, updating messageSent');
      setMessageSent(true);
    } catch (err) {
      console.error('Contact form error (fetch threw):', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const sharedTextFieldSx = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ccc',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#313647',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'rgb(255, 123, 41)',
    },
    '& .MuiFormHelperText-root': {
      backgroundColor: 'transparent',
      margin: '4px 0 0 0',
      padding: 0,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      backgroundColor: 'transparent',
    },
  };

  return (
    <div
      style={{
        minHeight: '90vh',
        display: 'flex',
        justifyContent: 'center',
        background: '#FAF3E1',
      }}
    >
      {/* iPad-width container */}
      <div
        style={{
          display: 'flex',
          width: '100%',
          maxWidth: '1024px',
        }}
      >
        {/* LEFT SIDE */}
        <div
          style={{
            flex: '0 0 50%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            lineHeight: '45px',
          }}
        >
          <div
            style={{
              fontSize: '50px',
              fontFamily: 'Playfair Display',
              fontWeight: 600,
              marginTop: '40%',
              color: '#181436',
            }}
          >
            Let’s scale your{' '}
          </div>
          <div
            style={{
              fontSize: '35px',
              fontFamily: 'Playfair Display',
              fontWeight: 600,
              marginBottom: '15px',
              color: '#181436',
            }}
          >
            business, together.
          </div>
          <img
            src={HOME_TOPIC_ONE}
            alt='Handshake'
            style={{
              width: '60%',
              maxWidth: '500px',
              height: 'auto',
            }}
          />
        </div>

        {/* RIGHT SIDE */}
        <div
          style={{
            flex: '0 0 50%',
            minHeight: '89vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        >
          {!messageSent ? (
            <Box
              style={{
                marginTop: '40px',
                background: '#ffffff',
                border: '2px solid #181436',
                padding: '30px',
                borderRadius: '20px',
                width: '80%',
                maxWidth: '460px',
              }}
            >
              <div
                style={{
                  fontSize: '30px',
                  fontFamily: 'Playfair Display',
                  marginBottom: '10px',
                  color: '#181436',
                }}
              >
                Get in touch with us
              </div>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label='Name'
                    variant='outlined'
                    size='small'
                    value={formData.firstName}
                    onChange={handleChange('firstName')}
                    error={Boolean(errors.firstName)}
                    helperText={errors.firstName}
                    sx={sharedTextFieldSx}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label='Last name'
                    variant='outlined'
                    size='small'
                    value={formData.lastName}
                    onChange={handleChange('lastName')}
                    error={Boolean(errors.lastName)}
                    helperText={errors.lastName}
                    sx={sharedTextFieldSx}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label='Email'
                    variant='outlined'
                    size='small'
                    value={formData.email}
                    onChange={handleChange('email')}
                    error={Boolean(errors.email)}
                    helperText={errors.email}
                    sx={sharedTextFieldSx}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label='Phone no'
                    variant='outlined'
                    size='small'
                    value={formData.phone}
                    onChange={handleChange('phone')}
                    error={Boolean(errors.phone)}
                    helperText={errors.phone}
                    sx={sharedTextFieldSx}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label='Zipcode'
                    variant='outlined'
                    size='small'
                    value={formData.zipcode}
                    onChange={handleChange('zipcode')}
                    error={Boolean(errors.zipcode)}
                    helperText={errors.zipcode}
                    sx={sharedTextFieldSx}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label='Company name'
                    variant='outlined'
                    size='small'
                    value={formData.company}
                    onChange={handleChange('company')}
                    error={Boolean(errors.company)}
                    helperText={errors.company}
                    sx={sharedTextFieldSx}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={6}
                    label='Your message'
                    variant='outlined'
                    value={formData.message}
                    onChange={handleChange('message')}
                    error={Boolean(errors.message)}
                    helperText={errors.message}
                    sx={sharedTextFieldSx}
                  />
                </Grid>

                <Grid item xs={12}>
                  <AtomicButton
                    label={isSubmitting ? 'Sending...' : 'Send message'}
                    handleSubmit={handleSubmit}
                    style={{ backgroundColor: '#181436', width: '100%' }}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Box
              style={{
                marginTop: '40px',
                background: '#ffffff',
                padding: '80px 30px 130px 30px',
                borderRadius: '20px',
                width: '80%',
                maxWidth: '460px',
                textAlign: 'center',
              }}
            >
              <img
                src={THANK_YOU_EMAIL_SENT}
                alt='Thank you'
                style={{
                  width: '200px',
                  height: 'auto',
                  marginBottom: '30px',
                }}
              />
              <div
                style={{
                  fontSize: '22px',
                  fontWeight: 600,
                  marginBottom: '10px',
                  color: '#313647',
                }}
              >
                Thank you for contacting us!
              </div>
              <div style={{ fontSize: '14px', color: '#555' }}>
                We’ve received your message and our team will reach out to you shortly.
              </div>
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
